module.exports = __webpack_public_path__ + "assets/img/11_999.3cd4bf25.jpg";